import { MM_PER_IN } from "../constants";

export const SIZE_PRESETS = [
  { label: '4×3"', width: 4, height: 3, unit: "in" },
  { label: '4×6"', width: 4, height: 6, unit: "in" },
];

export const FIELD_ELEMENTS = [
  { fieldKey: "firstName", label: "First Name" },
  { fieldKey: "lastName", label: "Last Name" },
  { fieldKey: "fullName", label: "Full Name" },
  { fieldKey: "email", label: "Email" },
  { fieldKey: "occupation", label: "Occupation" },
  { fieldKey: "category", label: "Category" },
];

export const FIELD_LABELS = FIELD_ELEMENTS.reduce((acc, f) => {
  acc[f.fieldKey] = f.label;
  return acc;
}, {});

export const toMm = (value, unit) =>
  unit === "in" ? value * MM_PER_IN : value;

const round2 = (n) => Math.round(n * 100) / 100;

// Converts a { width, height, unit } size to a new unit, scaling the numeric
// dimensions so the badge keeps its physical size (a 4×3in badge becomes
// ~102×76mm, not 4×3mm).
export const convertSize = (size, nextUnit) => {
  if (size.unit === nextUnit) return { ...size, unit: nextUnit };
  const factor = nextUnit === "mm" ? MM_PER_IN : 1 / MM_PER_IN;
  return {
    width: round2(size.width * factor),
    height: round2(size.height * factor),
    unit: nextUnit,
  };
};

export const elementDisplayName = (el) => {
  if (el.type === "field") return FIELD_LABELS[el.fieldKey] || el.fieldKey;
  if (el.type === "qr") return "QR Code";
  if (el.type === "rectangle") return "Rectangle";
  if (el.type === "text") return el.text ? el.text : "Text";
  return el.type;
};
